/* unplugin-vue-components disabled */import { render } from "./ShareUserRules.vue?vue&type=template&id=82972cea&scoped=true"
import script from "./ShareUserRules.vue?vue&type=script&lang=js"
export * from "./ShareUserRules.vue?vue&type=script&lang=js"

import "./ShareUserRules.vue?vue&type=style&index=0&id=82972cea&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82972cea"]])

export default __exports__